/**
 * Classe responsável por exibir a imagem do loading ao requisitar informações
 * @author: adalto.junior
 * Date: 30/10/13
 * Time: 14:30
 */


Monet.UI = Monet.UI || {};
Monet.UI.LoadingData = function () {

    var _el;
    var _i18n = Monet.I18n;
    var _text = _i18n.getResourcesByKey('Monet.UI.LoadingData.default');
    var containerToAppend = null;

    this.updateLoadingText = function (){
        if(_el){
            var divText = _el.querySelector('.MonetUILoadingDataText');
            divText.innerHTML = _text;
        }
    };

    this.setTextLabel = function (resource) {

        _text = _i18n.getResourcesByKey(resource);
        this.updateLoadingText();
    };

    this.getText = function () {
        return _text;
    };

    this.setContainerToAppend = function (_containerToAppend){
        containerToAppend = _containerToAppend;
    };

    this.getContainerToAppend = function (){
        if(!containerToAppend) {
            var tabName = Monet.Utils.GetTabName();
            containerToAppend = document.getElementById(tabName);
        }

        return containerToAppend;
    };

    this.render = function() {

        var divLoadingData = document.createElement('div');
        var divSpinner = document.createElement('div');
        var divText = document.createElement('div');

        divLoadingData.className = 'MonetUILoadingData';
        divSpinner.className = 'MonetUILoadingDataSpinner';
        divText.className = 'MonetUILoadingDataText';

        divText.innerHTML = this.getText();

        divLoadingData.appendChild(divSpinner);
        divLoadingData.appendChild(divText);

        return divLoadingData;

    };

    this.hide = function () {

        if (_el) {

            _el.style.display = 'none';

        }

    };

    this.show = function () {

        if (_el) {

            _el.style.display = 'block';

        }

    };

    this.init = function () {

        var element;
        var container = this.getContainerToAppend();

        if (container) {

            element = container.querySelector('.MonetUILoadingData');

            if (!element) {
                _el = this.render();
                container.appendChild(_el);
            } else {
                _el = element;
                this.updateLoadingText();
            }

        }

    };


};
